import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import account from './modules/account'
import address from './modules/address'
import upload from './modules/upload'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    account,
    address,
    upload
  },
  getters
})
